var map = {
	"./X-Twitter.svg": 25557,
	"./alert-circle.svg": 90658,
	"./arrow-left.svg": 43101,
	"./arrow-right.svg": 10043,
	"./blue-check-circle.svg": 32045,
	"./blue-cookie.svg": 17359,
	"./calendar.svg": 64083,
	"./check-circle.svg": 89865,
	"./check-small.svg": 61639,
	"./check.svg": 94531,
	"./chevron-down.svg": 36815,
	"./chevron-left.svg": 5827,
	"./chevron-right.svg": 45761,
	"./chevron-up.svg": 55917,
	"./close.svg": 73485,
	"./company.svg": 93213,
	"./copy.svg": 16895,
	"./corporate.svg": 79355,
	"./database.svg": 6336,
	"./delete.svg": 45369,
	"./discount.svg": 54011,
	"./dont-track.svg": 43174,
	"./download.svg": 85843,
	"./edit.svg": 93629,
	"./expenses.svg": 30306,
	"./external-link.svg": 95716,
	"./eye-off.svg": 60010,
	"./eye.svg": 47665,
	"./facebook.svg": 19421,
	"./file.svg": 29408,
	"./google.svg": 67050,
	"./grid.svg": 75082,
	"./group-structures.svg": 18995,
	"./help-button.svg": 45069,
	"./help-circle.svg": 56197,
	"./help.svg": 62400,
	"./hmrc.svg": 49152,
	"./home.svg": 62062,
	"./info.svg": 99022,
	"./invoice.svg": 3232,
	"./key.svg": 94120,
	"./layout.svg": 46242,
	"./left-chevron.svg": 85308,
	"./link-2.svg": 6335,
	"./link.svg": 68603,
	"./linkedin.svg": 37086,
	"./logout.svg": 29442,
	"./mail.svg": 73661,
	"./menu.svg": 40652,
	"./message-square.svg": 85261,
	"./minus.svg": 89430,
	"./package.svg": 8005,
	"./pencil.svg": 23294,
	"./personal.svg": 44725,
	"./plus.svg": 72867,
	"./qualify.svg": 93276,
	"./quickbooks.svg": 26441,
	"./recommendations.svg": 81912,
	"./refresh-cw.svg": 38495,
	"./repeat.svg": 90948,
	"./right-chevron.svg": 77183,
	"./search.svg": 5782,
	"./settings.svg": 26620,
	"./sidebar/corporate.svg": 94005,
	"./sidebar/cpu.svg": 37485,
	"./sidebar/home.svg": 77144,
	"./sidebar/package.svg": 82051,
	"./sidebar/poundsign.svg": 86346,
	"./sidebar/refresh-cw.svg": 61592,
	"./sidebar/rocket.svg": 15391,
	"./sidebar/settings.svg": 19805,
	"./sidebar/user.svg": 14379,
	"./sidebar/users.svg": 40199,
	"./smartphone.svg": 38730,
	"./special.svg": 86602,
	"./star.svg": 58683,
	"./support.svg": 95916,
	"./tax-bill.svg": 96108,
	"./tax-efficient.svg": 42977,
	"./thumb.svg": 38417,
	"./tick.svg": 30160,
	"./tracker.svg": 42846,
	"./trash.svg": 13405,
	"./trello.svg": 71608,
	"./twitter.svg": 20618,
	"./upload-cloud.svg": 96116,
	"./user-plus.svg": 29462,
	"./user.svg": 42012,
	"./users.svg": 47239,
	"./vertical-elipsis.svg": 2160,
	"./xero.svg": 13031,
	"public/images/icons/X-Twitter.svg": 25557,
	"public/images/icons/alert-circle.svg": 90658,
	"public/images/icons/arrow-left.svg": 43101,
	"public/images/icons/arrow-right.svg": 10043,
	"public/images/icons/blue-check-circle.svg": 32045,
	"public/images/icons/blue-cookie.svg": 17359,
	"public/images/icons/calendar.svg": 64083,
	"public/images/icons/check-circle.svg": 89865,
	"public/images/icons/check-small.svg": 61639,
	"public/images/icons/check.svg": 94531,
	"public/images/icons/chevron-down.svg": 36815,
	"public/images/icons/chevron-left.svg": 5827,
	"public/images/icons/chevron-right.svg": 45761,
	"public/images/icons/chevron-up.svg": 55917,
	"public/images/icons/close.svg": 73485,
	"public/images/icons/company.svg": 93213,
	"public/images/icons/copy.svg": 16895,
	"public/images/icons/corporate.svg": 79355,
	"public/images/icons/database.svg": 6336,
	"public/images/icons/delete.svg": 45369,
	"public/images/icons/discount.svg": 54011,
	"public/images/icons/dont-track.svg": 43174,
	"public/images/icons/download.svg": 85843,
	"public/images/icons/edit.svg": 93629,
	"public/images/icons/expenses.svg": 30306,
	"public/images/icons/external-link.svg": 95716,
	"public/images/icons/eye-off.svg": 60010,
	"public/images/icons/eye.svg": 47665,
	"public/images/icons/facebook.svg": 19421,
	"public/images/icons/file.svg": 29408,
	"public/images/icons/google.svg": 67050,
	"public/images/icons/grid.svg": 75082,
	"public/images/icons/group-structures.svg": 18995,
	"public/images/icons/help-button.svg": 45069,
	"public/images/icons/help-circle.svg": 56197,
	"public/images/icons/help.svg": 62400,
	"public/images/icons/hmrc.svg": 49152,
	"public/images/icons/home.svg": 62062,
	"public/images/icons/info.svg": 99022,
	"public/images/icons/invoice.svg": 3232,
	"public/images/icons/key.svg": 94120,
	"public/images/icons/layout.svg": 46242,
	"public/images/icons/left-chevron.svg": 85308,
	"public/images/icons/link-2.svg": 6335,
	"public/images/icons/link.svg": 68603,
	"public/images/icons/linkedin.svg": 37086,
	"public/images/icons/logout.svg": 29442,
	"public/images/icons/mail.svg": 73661,
	"public/images/icons/menu.svg": 40652,
	"public/images/icons/message-square.svg": 85261,
	"public/images/icons/minus.svg": 89430,
	"public/images/icons/package.svg": 8005,
	"public/images/icons/pencil.svg": 23294,
	"public/images/icons/personal.svg": 44725,
	"public/images/icons/plus.svg": 72867,
	"public/images/icons/qualify.svg": 93276,
	"public/images/icons/quickbooks.svg": 26441,
	"public/images/icons/recommendations.svg": 81912,
	"public/images/icons/refresh-cw.svg": 38495,
	"public/images/icons/repeat.svg": 90948,
	"public/images/icons/right-chevron.svg": 77183,
	"public/images/icons/search.svg": 5782,
	"public/images/icons/settings.svg": 26620,
	"public/images/icons/sidebar/corporate.svg": 94005,
	"public/images/icons/sidebar/cpu.svg": 37485,
	"public/images/icons/sidebar/home.svg": 77144,
	"public/images/icons/sidebar/package.svg": 82051,
	"public/images/icons/sidebar/poundsign.svg": 86346,
	"public/images/icons/sidebar/refresh-cw.svg": 61592,
	"public/images/icons/sidebar/rocket.svg": 15391,
	"public/images/icons/sidebar/settings.svg": 19805,
	"public/images/icons/sidebar/user.svg": 14379,
	"public/images/icons/sidebar/users.svg": 40199,
	"public/images/icons/smartphone.svg": 38730,
	"public/images/icons/special.svg": 86602,
	"public/images/icons/star.svg": 58683,
	"public/images/icons/support.svg": 95916,
	"public/images/icons/tax-bill.svg": 96108,
	"public/images/icons/tax-efficient.svg": 42977,
	"public/images/icons/thumb.svg": 38417,
	"public/images/icons/tick.svg": 30160,
	"public/images/icons/tracker.svg": 42846,
	"public/images/icons/trash.svg": 13405,
	"public/images/icons/trello.svg": 71608,
	"public/images/icons/twitter.svg": 20618,
	"public/images/icons/upload-cloud.svg": 96116,
	"public/images/icons/user-plus.svg": 29462,
	"public/images/icons/user.svg": 42012,
	"public/images/icons/users.svg": 47239,
	"public/images/icons/vertical-elipsis.svg": 2160,
	"public/images/icons/xero.svg": 13031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61868;